import axios from "axios";

export const getIsConnectedPos = (restId) => {
    // return axios.get(`/chain/api/menu/${restId}/isposconnected`).then((res) => res.data)
};

export const getPosConnection = (restId) => {
    // return axios.get(`/chain/api/menu/${restId}/posconnection`).then((res) => res.data)
};

export const getMenusFromPOS = (restId) => {
    // return axios.get(`/chain/api/menu/${restId}/posmenus`).then((res) => res.data)
};

export const allergensSave = (allergens) => {
    // let formData = new FormData();
    // formData.append("allergens", allergens);
    // return axios
    //     .post(`/chain/api/allergens`, formData, {
    //         headers: { "content-type": "multipart/form-data" },
    //         onUploadProgress: (e) => console.log(Math.floor((e.loaded * 100) / e.total)),}).then((res) => res.data)
};

export const getMenuList = (filters) => {
    return axios.get(`/chain/api/menu`, { params: filters }).then((res) => res.data)
};

export const createNewMenu = (params) => {
    return axios.post(`/chain/api/menu`, params)
};

export const getNewMenu = () => {
    // return axios.get(`/chain/api/menu-new`).then((res) => res.data)
};

export const getMenu = (restId) => {
    return axios.get(`/chain/api/menu/${restId}`).then((res) => res.data);
};

export const editMenu = ({ params, slug }) => {
    return axios
        .post(`/chain/api/menu/${slug}`, params)
        .then((res) => res.data);
};

export const updateMenuStatus = ({ body, slug }) => {
    return axios
        .post(`/chain/api/menu/${slug}/update-status`, body)
        .then((res) => res.data);
};

export const getMenuCategories = ({ slug, filters }) => {
    return axios
        .get(`/chain/api/menu/${slug}/categories`, {params: filters})
        .then((res) => res.data);
};

export const getMenuModifierCategories = ({ slug, filters }) => {
    return axios
        // .get(`/chain/api/menu/${slug}/categories`, {params: filters})
        // .then((res) => res.data);
};

export const newMenuSave = (values,selected,isCheckAllFutureLocations) => {
    // let formData = new FormData();
    // formData.append("values", JSON.stringify(values));
    // formData.append("selected", JSON.stringify(selected));
    // formData.append("isCheckAllFutureLocations", JSON.stringify(isCheckAllFutureLocations));

    // return axios
    //     .post(`/chain/api/menu-new`, formData, {
    //         headers: { "content-type": "multipart/form-data" },
    //         onUploadProgress: (e) =>
    //             console.log(Math.floor((e.loaded * 100) / e.total)),
    //     })
    //     .then((res) => res.data);
};

export const menuUpdate = (restId, values,selected,isCheckAllFutureLocations) => {
    // let formData = new FormData();
    // formData.append("values", JSON.stringify(values));
    // formData.append("selected", JSON.stringify(selected));
    // formData.append("isCheckAllFutureLocations", JSON.stringify(isCheckAllFutureLocations));

    // return axios
    //     .post(`/chain/api/menu/${restId}`, formData, {headers: { "content-type": "multipart/form-data" },
    //         onUploadProgress: (e) =>console.log(Math.floor((e.loaded * 100) / e.total)),}).then((res) => res.data)
};

export const menuArchivate = (archived, menuId) => {
    // let formData = new FormData();
    // formData.append("archived", archived)

    // return axios.post(`/chain/api/menu/${menuId}`, formData, {params: { archived}}).then((res) => res.data)
};


